import { EditButton as RaEditButton } from "react-admin";
import React from "react";
import useIsDisabled from "../useIsDisabled";

const EditButton = (props) => {
  const disabled = useIsDisabled(props);
  return <RaEditButton {...props} disabled={disabled} />;
};

export default EditButton;
